export const PLUGIN_VERSION = '5.3.4';
export const SITE_LANG = 'en_US';
export const PLUGIN_NAME = 'WordPress Voting Photo Contest Plugin';
export const PLUGIN_URL = '/wp-content/plugins/wp-voting-contest/';
export const WPVC_VOTES_TYPE = 'contestants';
export const WPVC_VOTES_TAXONOMY = 'contest_category';
export const WPVC_VOTES_CUSTOMFIELD = 'votes_count';
export const WPVC_VOTES_EXPIRATIONFIELD = 'votes_expiration';
export const WPVC_VOTES_SETTINGS = 'wpvc_votes_settings';
export const WPVC_SKIP_FIELDS = ['contestant-title','contestant-desc','contestant-image'];
